import { memo } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { RedirectContainer } from '~src/styles/shared.sc';
import { routes } from '~src/routingConfig';
import {
  SubHeader,
  RedirectContentWrapper,
  LinkContainer,
  ObjectiveDoneMessageContainer,
} from '~src/modules/okrs/objectivesStream/shared.sc';
import ObjectiveProgress from '~src/modules/okrs/objectivesStream/objectiveUpdated/objectiveProgress/ObjectiveProgress';
import NavArrowLnk from '~src/shared/buttons/NavArrowLnk';
import { white } from '~src/styles/colors/index';

interface OwnProps {
  // todo: receive it from query params
  name: string;
  progress: number;
}

type Props = OwnProps & RouteComponentProps<any>;

const NoMoreToUpdate = memo((props: Props) => {
  const [t] = useTranslation();
  const handleClick = () => {
    props.history.push(routes.okrs.list);
  };

  return (
    <RedirectContainer>
      <RedirectContentWrapper $height={'auto'} $redirect={false}>
        <ObjectiveProgress name={props.name} progress={props.progress} blurOnMobile={false} />
        <ObjectiveDoneMessageContainer>
          <SubHeader>{t('x.okr.update_stream.objective_updated.no_more_to_do_message')}</SubHeader>
          <LinkContainer onClick={handleClick}>
            <NavArrowLnk arrowDir="right" color={white.a10}>
              {t('x.okr.update_stream.objective_updated.objective_overview')}
            </NavArrowLnk>
          </LinkContainer>
        </ObjectiveDoneMessageContainer>
      </RedirectContentWrapper>
    </RedirectContainer>
  );
});

const NoMoreToUpdateSuper = withRouter(NoMoreToUpdate);

export default NoMoreToUpdateSuper;
